import React, { useEffect } from "react";
import { Boxed } from "../../components/Boxed.components";
import { DropDownMenu, PageTitle } from "../../components/style";
import Wrapper from "../Common/FilterWrapper/index";
import {
  PaginationComponent,
  TableComponent,
} from "../../components/Table.components";
import { Button } from "../../components/Button.components";
import { EmptyState } from "../../components/EmptyState.components";
import { Input } from "../../components/Input.components";
import { Grid } from "../../components/Grid.components";
import { Avatar } from "../../components/Avatar.components";
import { Loader } from "../../components/Loader.components";
import { formatDateTime } from "../../utils/utils";
import { pageOptions } from "../../utils/constant";
import CreateModal from "./CreateModal/index";
import { Theme } from "../../utils/theme";

export const DepartmentManagement = (props) => {
  // state props
  const { fetchActionURL, departmentsTotal, departmentsList, createDepartmentModal, isLoading } = props;

  // dispatch props
  const { getAllDepartments, openCreateModal, redirect } = props;

  useEffect(() => {
    let data = {
      page: 1,
      size: 10,
    };
    getAllDepartments(data);
  }, []);


  const columns = [
    {
      title: "Department Name",
      dataIndex: "companyLogoUrl",
      key: "companyLogoUrl",
      render: (text, record) => (
        <Avatar
          src={record?.companyLogoUrl}
          size={"38px"}
          name={record?.description}
          // info={`Managed by ${record?.contactPerson?.name}`}
          borderRadius={Theme.PrimaryRadius}

        />
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => text && formatDateTime(text),
    },
    // {
    //   title: "",
    //   dataIndex: "action",
    //   key: "action",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <DropDownMenu
    //         list={dropdownList}
    //         // handleAction={(value) => handleDropDown(value, record)}
    //       />
    //     );
    //   },
    // },
  ];
  return (
    <>

    <Boxed pad="20px">
      <PageTitle>Department Management</PageTitle>
      <Boxed pad="20px 10px">
        
        <Wrapper
          externalActionURL={fetchActionURL}
          render={({
            changePageSize,
            handlePagination,
            currentPage,
            pageSize,
            search,
          }) => {
            return (
              <>
                <Grid
                  desktop="repeat(4, 1fr)"
                  tablet="repeat(4, 1fr)"
                  mobile="repeat(1, 1fr)"
                >
                  <Boxed pad="5px 0">
                    <Input
                      type="search"
                      placeholder="Search by department name"
                      onChange={(value) => search(value, fetchActionURL)}
                    />
                  </Boxed>
                  <Boxed />
                  <Boxed />
                  <Boxed pad="5px 0" align="right">
                    <Button
                      onClick={() => openCreateModal()}
                    >
                      Add Department
                    </Button>
                  </Boxed>
                </Grid>
                {isLoading ? (
                  <Boxed display="flex" pad="20px">
                    <Loader margin="auto" />
                  </Boxed>
                ) : (
                  <>
                    {" "}
                    {departmentsTotal > 0 ? (
                      <>
                        <TableComponent columns={columns} data={departmentsList} />
                        <Boxed pad="10px 0 ">
                          <PaginationComponent
                            total={departmentsTotal}
                            onChange={(page) =>
                              handlePagination(page, fetchActionURL)
                            }
                            current={currentPage}
                            pageCounts={pageOptions}
                            changePageSize={(pageSize) =>
                              changePageSize(pageSize, fetchActionURL)
                            }
                            pageSize={pageSize}
                            itemsDisplayed
                            showTotal={(total, range) => {
                              return `${range[0]} - ${range[1]} of ${departmentsTotal} items`;
                            }}
                          />
                        </Boxed>
                      </>
                    ) : (
                      <EmptyState />
                    )}
                  </>
                )}
              </>
            );
          }}
        />
      </Boxed>
    </Boxed>
    {createDepartmentModal && <CreateModal />}
    </>
  );
};
